"use strict";
/**
 * @packageDocumentation
 * @module harmony-account
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessenger = void 0;
var network_1 = require("@harmony-js/network");
var utils_1 = require("@harmony-js/utils");
exports.defaultMessenger = new network_1.Messenger(new network_1.HttpProvider('http://localhost:9500'), utils_1.ChainType.Harmony, utils_1.ChainID.HmyLocal);
//# sourceMappingURL=utils.js.map